export const robotTriggers = [
  {
    label: 'ChangeRecordStatus',
    title: 'Смена статуса записи',
  },
  { label: 'ByTimer', title: 'По истечении времени' },
  {
    label: 'ChannelIsEstablished',
    title: 'Установка канала связи',
  },
  {
    label: 'TagIsSet',
    title: 'Наличие тега',
  },
  {
    label: 'DateRecord',
    title: 'Дата записи',
  },
  {
    label: 'AiClientSearch',
    title: 'Поиск клиентов через ИИ',
  },
];
